import type { FC } from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Box, Button, Stack, Typography, useTheme } from '@mui/material'
import Paper from 'components/@extended/Paper'

interface SmartImportNoChangesProps {
  onUploadAnother: () => void
  onViewRewards: () => void
}

const SmartImportNoChanges: FC<SmartImportNoChangesProps> = ({ onUploadAnother, onViewRewards }) => {
  const theme = useTheme()

  return (
    <Paper sx={{ p: { xs: 2.5, md: 3 }, width: '100%' }}>
      <Stack spacing={2}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <InfoCircleOutlined style={{ color: theme.palette.info.main, fontSize: 22 }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              No new items to import
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Everything in this file already exists. Upload another file or view rewards.
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onUploadAnother}>
            Upload another file
          </Button>
          <Button variant="contained" onClick={onViewRewards}>
            Go to rewards
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default SmartImportNoChanges
